export const US_ENTRY_SUMMARY = 'Entry requirements depend on traveler citizenship and purpose. Check official U.S. visa guidance before travel.';
export const US_VISA_URL = 'https://travel.state.gov/content/travel/en/us-visas.html';

export const isUnitedStatesReport = (report: any): boolean => {
    const code = String(report?.iso3 || report?.iso2 || report?.countryCode || '').toUpperCase();
    const name = String(report?.country || report?.countryName || '').trim();
    return code === 'USA' || code === 'US' || /^(United States(?: of America)?|USA|US)$/i.test(name);
};
